import {api} from '@/lib/api';

export interface InviteConfig {
    role: 'owner' | 'leader';
    groups: Array<{ id: string; name: string }>;
    membershipConfigurations: Array<{
        id: string; name: string; price: number;
        currency: string; period: string; isFree: boolean;
    }>;
}

export async function getInviteConfig(orgId: string): Promise<InviteConfig> {
    const xhr = await api.get<InviteConfig>(`/invitations/config/${orgId}`);
    return xhr.data;
}

interface CreateQrInvitationParams {
    organization: string;
    invitedBy: string;
    membershipConfiguration: string;
    group?: string;
}

interface CreateQrInvitationResponse {
    id: string;
    url: string;
}

export async function createQrInvitation(params: CreateQrInvitationParams): Promise<CreateQrInvitationResponse> {
    const xhr = await api.post<CreateQrInvitationResponse>('/invitations', {
        inviteType: 'qr',
        organization: params.organization,
        invitedBy: params.invitedBy,
        membershipConfiguration: params.membershipConfiguration,
        group: params.group || '',
        isLeader: false,
        emailEnforced: false,
        email: '',
    });
    return xhr.data;
}
